"use client";

import { Box, Typography } from "@mui/material";
import { theme } from "@/lib/theme";

interface ArticleTitleProps {
  title: string;
  subtitle: string;
  author: string;
  published: string;
}

export const ArticleTitle = ({ title, subtitle, author, published }: ArticleTitleProps) => {
  return (
    <Box
      sx={{
        background: `linear-gradient(to bottom, ${theme.colors.darkLimeGreen}, ${theme.colors.white})`,
        width: "100vw",
        position: "relative",
        left: "50%",
        right: "50%",
        marginLeft: "-50vw",
        marginRight: "-50vw",
        textAlign: "center",
        padding: {
          xs: "32px 24px",
          sm: "48px 32px",
          md: "64px 48px",
        },
      }}
    >
      <Typography
        variant="h1"
        component="h1"
        sx={{
          color: theme.colors.black,
          margin: "0 auto",
          maxWidth: "900px",
          marginBottom: {
            xs: 3,
            sm: 4,
          },
        }}
      >
        {title}
      </Typography>

      <Typography
        variant="h2"
        component="h2"
        sx={{
          color: theme.colors.black,
          margin: "0 auto",
          maxWidth: "900px",
          marginTop: {
            xs: 0,
            sm: 0,
          },
          marginBottom: {
            xs: 4,
            sm: 5,
          },
        }}
      >
        {subtitle}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          color: theme.colors.black,
          maxWidth: "900px",
          margin: "0 auto",
        }}
      >
        {author}
        <br />
        {published}
      </Typography>
    </Box>
  );
};
